import { getEnv } from '@next-box/envs/server';
import { addYears, format } from 'date-fns';
import { type SortFilterOptions } from '../components/Discover/types.ts';

// NOTE: id 210024 maps to 'animie'

export const movieOptions: SortFilterOptions = {
  POPULARITY_DESC: [
    'Popularity',
    {
      voteCountGte: 10,
    },
  ],
  PRIMARY_RELEASE_DATE_DESC: [
    'Release date',
    {
      primaryReleaseDateLte: format(addYears(new Date(), 2), 'yyyy-MM-dd'),
      withOriginalLanguage: getEnv<'en' | 'es' | 'fr'>('NEXT_PUBLIC_LANGUAGE_CODE'),
    },
  ],
  REVENUE_DESC: [
    'Revenue',
    {
      voteCountGte: 10,
    },
  ],
  VOTE_AVERAGE_DESC: [
    'Vote average',
    {
      voteCountGte: 500,
    },
  ],
  VOTE_COUNT_DESC: [
    'Vote count',
    {
      voteCountGte: 500,
    },
  ],
};

export const tvOptions: SortFilterOptions = {
  FIRST_AIR_DATE_DESC: [
    'First air date',
    {
      firstAirDateLte: format(addYears(new Date(), 2), 'yyyy-MM-dd'),
      includeNullFirstAirDates: false,
      withOriginalLanguage: getEnv<'en' | 'es' | 'fr'>('NEXT_PUBLIC_LANGUAGE_CODE'),
    },
  ],
  POPULARITY_DESC: [
    'Popularity',
    {
      voteCountGte: 10,
    },
  ],
  VOTE_AVERAGE_DESC: [
    'Vote average',
    {
      voteCountGte: 500,
    },
  ],
};
